import { render, staticRenderFns } from "./AmazonDialog.vue?vue&type=template&id=3c5b10f6&scoped=true"
import script from "./AmazonDialog.vue?vue&type=script&lang=js"
export * from "./AmazonDialog.vue?vue&type=script&lang=js"
import style0 from "./AmazonDialog.vue?vue&type=style&index=0&id=3c5b10f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5b10f6",
  null
  
)

export default component.exports